import { memo } from 'react';

import ClassificationIcon from '@/assets/classification-icon.svg?react';
import { merge } from '@/components';
import { FormatterValidatorLogo, VariantLogoProps } from '@/components/logos';

export type ClassificationLogoProps = VariantLogoProps;

const IClassificationLogo = ({ className, ...rest }: ClassificationLogoProps) => {
  return (
    <FormatterValidatorLogo
      Icon={ClassificationIcon}
      className={merge('bg-warning-50] text-warning-700', className)}
      {...rest}
    />
  );
};

export const ClassificationLogo = memo(IClassificationLogo) as typeof IClassificationLogo;
